import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
import { SlTab, SlTabGroup, SlTabPanel } from '@shoelace-style/shoelace/dist/react';
import Advertiser from './Advertiser'
import { useDispatch, useSelector } from 'react-redux';
import { SetComponentId } from '../../redux/counterSlice'
import Sales from './Sales'
import Finance from './Finance'
import { roles } from '../../utils/constants';
import B2B from './B2b'
import CryptoJS from 'crypto-js';
import config from '../../config.js';
import Company from './Company';
import Legal from "./Legal"
import Designer from './Designer';
import ContentWriter from './ContentWriter.js';
import MakerChecker from '../MakerChecker/MakerChecker.js';
import CST from './CST.js';
import Classifieds from './Classifieds.js';
import UserVendor from '../vendor/UserVendor.js';

function Users() {
  const dispatch = useDispatch()
  dispatch(SetComponentId(1))
  const navigate = useNavigate()
  let salesUserType = "", activeModifiedType=""
  if (localStorage.getItem('role') === roles.salesperson && localStorage.getItem('salesTabFlag')) {
    const decryptedSalesTabPermissions = CryptoJS.AES.decrypt(localStorage.getItem('salesTabFlag'), config.B2B_SECRET_KEY);
    salesUserType = decryptedSalesTabPermissions.toString(CryptoJS.enc.Utf8)
    activeModifiedType = "sales"
  }
  else{
    activeModifiedType = "company"
  }
  const { tab } = useParams()
  const [activeTab, setActiveTab] = useState(tab || activeModifiedType)

  useEffect(() => {
    const role = localStorage.getItem("role")
    if ((role !== roles.ops && role !== roles.financer && role !== roles.b2b) && !salesUserType) {
      navigate("/pagenotfound")
    }
  }, [navigate])

  useEffect(() => {
    if (tab && tab !== activeTab) setActiveTab(tab)
  }, [tab])

  const handleTabActivate = (event) => {
    const name = event.detail.name
    setActiveTab(name)
    navigate(`/home/users/${name}`, { replace: true })
  }
  return (
    <div className="form-floating users-mgmt">{console.log(salesUserType)}
      <SlTabGroup onSlTabShow={handleTabActivate}>
        {!salesUserType && <><SlTab slot="nav" panel="company" active={activeTab === 'company'}>Company</SlTab>
          <SlTabPanel name="company">{activeTab === 'company' && <Company />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') !== roles.financer && <><SlTab slot="nav" panel="advertiser" active={activeTab === 'advertiser'}>Advertiser</SlTab>
          <SlTabPanel name="advertiser">{activeTab === 'advertiser' && <Advertiser />}</SlTabPanel></>}
        {localStorage.getItem('role') !== roles.financer && <SlTab slot="nav" panel="sales" active={activeTab === 'sales'}>Sales</SlTab>}
        <SlTabPanel name="sales">{activeTab === 'sales' && <Sales />}</SlTabPanel>
        {!salesUserType && localStorage.getItem('role') !== roles.financer && <><SlTab slot="nav" panel="finance" active={activeTab === 'finance'}>Finance</SlTab>
        <SlTabPanel name="finance">{activeTab === 'finance' && <Finance />}</SlTabPanel>
        <SlTab slot="nav" panel="b2b" active={activeTab === 'b2b'}>B2B</SlTab>
          <SlTabPanel name="b2b">{activeTab === 'b2b' && <B2B />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') !== roles.financer && <><SlTab slot="nav" panel="legal" active={activeTab === 'legal'}>Legal</SlTab>
          <SlTabPanel name="legal">{activeTab === 'legal' && <Legal />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') === roles.b2b && <><SlTab slot="nav" panel="designer" active={activeTab === 'designer'}>Designer</SlTab>
          <SlTabPanel name="designer">{activeTab === 'designer' && <Designer />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') === roles.b2b && <><SlTab slot="nav" panel="ContentWriter" active={activeTab === 'ContentWriter'}>ContentWriter</SlTab>
          <SlTabPanel name="ContentWriter">{activeTab === 'ContentWriter' && <ContentWriter />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') === roles.b2b && <><SlTab slot="nav" panel="cst" active={activeTab === 'cst'}>CST</SlTab>
          <SlTabPanel name="cst">{activeTab === 'cst' && <CST />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') === roles.b2b && <><SlTab slot="nav" panel="classifieds" active={activeTab === 'classifieds'}>Classifieds</SlTab>
          <SlTabPanel name="classifieds">{activeTab === 'classifieds' && <Classifieds />}</SlTabPanel></>}
        {!salesUserType && localStorage.getItem('role') === roles.b2b && <><SlTab slot="nav" panel="vendor" active={activeTab === 'vendor'}>Vendor</SlTab>
          <SlTabPanel name="vendor">{activeTab === 'vendor' && <UserVendor />}</SlTabPanel></>}
      </SlTabGroup>
      {/* <Tabs activeKey={tab}
        onSelect={(k) => setTab(k)}
        className="mb-1" >
        <Tab eventKey="advertiser" title="Advertiser">
          {tab === "advertiser" && < Advertiser />}
        </Tab>
        <Tab eventKey="sales" title="Sales">
          {tab === "sales" && <Sales />}
        </Tab>
        <Tab eventKey="finance" title="Finance" >
          {tab === "finance" && <Finance />}
        </Tab>
      </Tabs> */}
    </div>
  )
}

export default Users
